import React, { useState, useEffect } from "react";

const SplashScreen = ({ customerInfo }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 1 : 100));
    }, 30); // 30ms마다 프로그레스 바를 1%씩 증가
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="sm:w-full md:max-w-[375px] mx-auto min-h-screen  relative overflow-hidden  flex justify-center bg-white" 
      // style={{ background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, #bcdfff 92.19%)" }}
    >
      <div className="absolute top-0 left-0 bg-[#3e9ff9] " style={{ width: `${progress}%`, height: "4px" }} />

      <div className="flex flex-col justify-center items-center w-full absolute left-0 top-[466px] gap-[18px] py-[25px]">
        <p className="flex-grow-0 flex-shrink-0 w-full  font-bold text-center">
          <span className="flex-grow-0 flex-shrink-0 w-full text-[22px] font-bold text-center text-black">{`${customerInfo?.고객명 || "테스트"} 고객님!`}</span>
          <br />
          <br />
          <span className="flex-grow-0 flex-shrink-0 w-full  text-base font-bold text-center text-[#5f5f5f]">참좋은 홈쇼핑 프로모션에 </span>
          <br />
          <span className="flex-grow-0 flex-shrink-0 w-full  text-base font-bold text-center text-[#5f5f5f]">참여해주셔서 감사합니다.</span>
        </p>
      </div>
      <div className="absolute  top-[331px] text-[25px] font-bold text-center text-[#5f5f5f]">{` ${customerInfo?.캠페인명 || "캠페인명"}`} </div>
      <div className="flex flex-col justify-start items-center w-full absolute left-0 top-[148px] gap-3 py-[25px]">
        <img src="/assets/img/logo1.png" className="flex-grow-0 flex-shrink-0 w-[150px] h-[47px] object-cover" />
        <p className="flex-grow-0 flex-shrink-0 text-lg font-bold ttext-center text-[#6a6a6a]">{` ${customerInfo?.매체 || ""}`}</p>
      </div>
    </div>
  );
};

export default SplashScreen;
